export enum PorposalModality {
  PROPUESTAINDIVIDUAL = 1,
  PROPUESTACONSORCIONADA = 2,
  PROPUESTAARTICULADAS = 3
}
